var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 361,
    viewBox: "0 0 256 361",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.844 360.088L23.6619 331.166L0.444946 70.766H255.555L232.314 331.126L127.844 360.088V360.088Z",
    fill: "#264DE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M212.417 314.547L232.277 92.057H128V337.95L212.417 314.547V314.547Z",
    fill: "#2965F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.669 188.636L56.531 220.573H128V188.636H53.669ZM47.917 123.995L50.82 155.932H128V123.995H47.917V123.995ZM128 271.58L127.86 271.617L92.292 262.013L90.018 236.542H57.958L62.432 286.688L127.853 304.848L128 304.808V271.58Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.484 0H99.164V16.176H76.66V32.352H99.166V48.527H60.484V0ZM106.901 0H145.582V14.066H123.077V16.879H145.582V49.231H106.902V34.46H129.407V31.647H106.9V0H106.901ZM153.319 0H192V14.066H169.495V16.879H192V49.231H153.319V34.46H175.824V31.647H153.32V0H153.319Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M202.127 188.636L207.892 123.995H127.89V155.932H172.892L169.986 188.636H127.89V220.573H167.217L163.509 261.993L127.889 271.607V304.833L193.362 286.688L193.842 281.292L201.348 197.212L202.127 188.636V188.636Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.2365805cccad5d4bfc17225bbf9987a7.svg";
export { ForwardRef as ReactComponent };